var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3162 2.80646L8.0403 12.0806C7.78398 12.3369 7.43804 12.4785 7.07776 12.4785C6.71748 12.4785 6.36974 12.3351 6.11342 12.0806L0.549659 6.51683C0.0173013 5.98447 0.0173013 5.1223 0.549659 4.58995C1.08202 4.05759 1.94418 4.05759 2.47654 4.58995L7.07776 9.18937L15.3893 0.877784C15.9217 0.345426 16.7839 0.345426 17.3162 0.877784C17.8486 1.41014 17.8486 2.2741 17.3162 2.80646Z",
    fill: "#47DE89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnable);
export default __webpack_public_path__ + "static/media/enable.076bdcfffda84277d74a0b190ae01968.svg";
export { ForwardRef as ReactComponent };